import { Box, Skeleton } from '@mui/material';

const InputSkeleton = () => (
  <Box sx={{ mt: 2 }}>
    <Skeleton sx={{ width: '10rem' }} />
    <Skeleton sx={{ width: '100%', height: '4rem' }} variant="rounded" />
  </Box>
);

export const UpdateSRSkeleton = () => (
  <Box>
    <Skeleton sx={{ fontSize: '2.4rem', width: '30rem' }} />
    <Skeleton sx={{ mt: 2, mb: 1, width: '15rem' }} />
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Skeleton sx={{ width: '10rem', height: '10rem' }} variant="rounded" />
      <Box>
        {Array.from({ length: 4 }).map((v, i) => (
          <Skeleton key={i} sx={{ width: '15rem' }} />
        ))}
      </Box>
    </Box>
    <Box sx={{ mt: 2 }}>
      <Skeleton sx={{ width: '5rem' }} />
      <Skeleton sx={{ width: '25rem' }} />
    </Box>
    {Array.from({ length: 2 }).map((v, i) => (
      <InputSkeleton key={i} />
    ))}
    <Skeleton sx={{ mt: 3, width: '25rem' }} />
    <hr />
    <InputSkeleton />
    <hr />
    <Box sx={{ mt: 2, mb: 4 }}>
      <Skeleton sx={{ width: '15rem' }} />
      <Skeleton sx={{ width: '25rem' }} />
    </Box>
    <InputSkeleton />
    <Skeleton sx={{ my: 2, width: '30rem' }} />
    <Skeleton sx={{ width: '13rem', height: '4rem' }} variant="rounded" />
  </Box>
);
